<script setup>
/**
 * @fileoverview TabsContent component
 * @description Content panel for a tab
 */
import { TabsContent as TabsContentPrimitive } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  value: {
    type: String,
    required: true
  },
  class: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <TabsContentPrimitive
    :value="value"
    :class="
      cn(
        'mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        props.class
      )
    "
  >
    <slot />
  </TabsContentPrimitive>
</template>
